import React, { useState } from "react";
import axios from "axios";
import { config } from "../../../../../config";

const apiUrl = config.apiUrl;

const CreateApi = ({ onBrevoApiCreated }) => {
  const [formData, setFormData] = useState({
    slug: "",
    api: "",
    list: "",
  });

  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post(`${apiUrl}/automations`, formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      alert("Automation Created Successfully!");
      onBrevoApiCreated();
    } catch (err) {
      setError("An error occurred while creating the automation.");
    }
  };

  return (
    <div className="p-6 max-w-lg mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Create Automation</h2>
      {error && <p className="text-red-500">{error}</p>}
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-gray-700">Slug</label>
          <input
            type="text"
            name="slug"
            value={formData.slug}
            onChange={handleChange}
            className="border w-full p-2"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">API</label>
          <input
            type="text"
            name="api"
            value={formData.api}
            onChange={handleChange}
            className="border w-full p-2"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">List</label>
          <textarea
            name="list"
            value={formData.list}
            onChange={handleChange}
            className="border w-full p-2"
            required
          />
        </div>
        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Create Automation
        </button>
      </form>
    </div>
  );
};

export default CreateApi;
